// Componentes
import TextCustom from '../TextCustom';

const MensajeError = ({ mensaje = '', alignError = 'left' }) => {
  return (
    <div
      className={`flex gap-2  ${
        alignError === 'left' ? 'justify-start' : 'justify-center'
      } items-center mt-2.5`}
    >
      <TextCustom
        text={mensaje}
        className="text-xs fontPRegular color-danger"
      />
    </div>
  );
};

export default MensajeError;
